export default {
  id: 215,
  title: 'Target #215 - Staggered checks',
  url: 'https://cssbattle.dev/play/215',
  colors: ['#6867D4', '#000039'],
  solution:
    '<style>body{background:conic-gradient(from 135deg at 200px 9px,transparent 90deg,#6867d4 90deg),conic-gradient(from -45deg at 200px 280px,transparent 90deg,#6867d4 90deg),linear-gradient(45deg,transparent 204px,#6867d4 204px 212px,transparent 212px 252px,#6867d4 252px 260px,transparent 260px 291px,#6867d4 291px 299px,transparent 299px 323px,#6867d4 323px 331px,transparent 331px),linear-gradient(-45deg,#000039 204px,#6867d4 204px 212px,#000039 212px 252px,#6867d4 252px 260px,#000039 260px 291px,#6867d4 291px 299px,#000039 299px 323px,#6867d4 323px 331px,#000039 331px)',
}
